<template>
  <div class="columns">
    <div class="column is-12">
      <div id="lineAlign" :style="boxStyles">
        <svg :style="svgStyle">
          <g :transform="`translate(${angle_lines.box_styles.width/2},${angle_lines.box_styles.height/2}) scale(1,-1)`">
            <path :style="strokeStyle" :d="makeLine(this.angle_lines.line_length)"/>
            <circle :style="fillColor" :r="this.angle_lines.pivot_radius" cx=0 cy=0></circle>
            <path  :style="angleStyle" :d="describeArc(0,0,20)"/>
            <path :style="startArrowStyle" :d="makeStartArrow(this.angle_lines.line_length)"/>
            <path :style="endArrowStyle" :d="makeEndArrow(this.angle_lines.line_length)"/>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import { getCSSFromStyles } from '../../Common/StyleEditor/utils';
export default {
  name: "show-angle-lines",
  props: {
    angle_lines: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods:{
    polarToCartesian(centerX, centerY, radius, angleInDegrees) {
      const angleInRadians = (angleInDegrees) * Math.PI / 180.0;

      return {
        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians))
      };
    },    
    describeArc(x, y, radius){
      const startAngle = this.angle_lines.angle_start
      const endAngle = this.angle_lines.angle_between+this.angle_lines.angle_start
      const end = this.polarToCartesian(x, y, radius, endAngle);
      const start = this.polarToCartesian(x, y, radius, startAngle);

      const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
      let d = [
            "M", start.x, start.y, 
            "A", radius, radius, 0, largeArcFlag, 1, end.x, end.y
        ].join(" ");
      if(this.angle_lines.angle_between==90){
        d = [
          "M", start.x, start.y, 
          "L", start.x+end.x,end.y+start.y,
          "L", end.x, end.y
        ].join(" ");
      }
      return d;
    },
    makeLine(radius){
      const start=this.polarToCartesian(0,0,radius,this.angle_lines.angle_start);
      const end=this.polarToCartesian(0,0,radius,this.angle_lines.angle_between+this.angle_lines.angle_start)
      let d = [
          "M", start.x, start.y, 
          "L", 0, 0,
          "L", end.x, end.y
      ].join(" ");
      
      return d;
    },
    makeStartArrow(len){
      let d = [
        "M", len-10, 10,
        "L", len, 0,
        "L", len-10, -10
      ].join(" ");
      return d;
    },
    makeEndArrow(len){
      let d = [
        "M", len-10, 10,
        "L", len, 0,
        "L", len-10, -10
      ].join(" ");
      return d;
    }
  },
  computed:{
      boxStyles(){
          return{
              ...getCSSFromStyles(this.angle_lines.box_styles),
          }
      },
      strokeStyle(){
        return{
          "stroke":`${this.angle_lines.line_styles.bg_color}`,
          "stroke-width":`${this.angle_lines.line_stroke_width}`,
          "fill":"none  "
        }
      },
      fillColor(){
        return{
          "fill":`${this.angle_lines.line_styles.bg_color}`
        }
      },
      startArrowStyle(){
        return{
            "transform":`rotate(${this.angle_lines.angle_start}deg)`,
            ...this.strokeStyle
        }
      },
      endArrowStyle(){
        return{
            "transform":`rotate(${this.angle_lines.angle_start+this.angle_lines.angle_between}deg)`,
            ...this.strokeStyle
        }
      },
      angleStyle(){
        if(this.angle_lines.angle_between==90){
          return{
            // "transform":`rotate(${this.angle_lines.angle_start}deg)`,
            ...this.strokeStyle
          }
        }
        else{
          return{
            ...this.strokeStyle
          }
        }
      },
      svgStyle(){
        return{
          "height":`${this.angle_lines.box_styles.height}`,
          "width":`${this.angle_lines.box_styles.width}`
        }
      }
  }
}

</script>
<style scoped>
#lineAlign {
  position: relative;
  display: flex;
  justify-content: center;
}
</style>